var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgXMedium(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 26,
    viewBox: "0 0 27 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.334 25C19.9614 25 25.334 19.6274 25.334 13C25.334 6.37258 19.9614 1 13.334 1C6.70657 1 1.33398 6.37258 1.33398 13C1.33398 19.6274 6.70657 25 13.334 25Z",
    stroke: "#ADBEEB",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.58252 9.12852H9.38286L9.50244 9.28841L12.6295 13.4695L9.48911 16.8621L9.33367 17.03H9.5625H10.2821H10.3258L10.3555 16.998L13.0729 14.0622L15.2625 16.9899L15.2925 17.03H15.3426H17.7911H17.9907L17.8712 16.8701L14.5653 12.4501L17.4844 9.29644L17.6399 9.12852H17.411H16.6915H16.6478L16.6181 9.16059L14.122 11.8573L12.1111 9.16862L12.0811 9.12852H12.031H9.58252ZM15.658 16.3L10.8404 9.85852H11.7155L16.5331 16.3H15.658Z",
    fill: "#1D3679",
    stroke: "#1D3679",
    strokeWidth: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXMedium);
export default __webpack_public_path__ + "static/media/xMedium.e51e5e02802b4beb8247bdf7fd1680ca.svg";
export { ForwardRef as ReactComponent };